import client from './client';
import type { Location } from '@/types/api';

export const locationsApi = {
  getAll: async (): Promise<Location[]> => {
    const response = await client.get<Location[]>('/locations');
    return response.data;
  },

  getById: async (id: string): Promise<Location> => {
    const response = await client.get<Location>(`/locations/${id}`);
    return response.data;
  },

  create: async (data: Partial<Location>): Promise<Location> => {
    const response = await client.post<Location>('/locations', data);
    return response.data;
  },

  update: async (id: string, data: Partial<Location>): Promise<Location> => {
    const response = await client.put<Location>(`/locations/${id}`, data);
    return response.data;
  },

  delete: async (id: string): Promise<void> => {
    await client.delete(`/locations/${id}`);
  },
};
